/// <reference path="../../_ext/Bases/DialogBase.ts" />
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    @Serenity.Decorators.maximizable()
    @Serenity.Decorators.responsive()
    export class DesignDialog extends _Ext.DialogBase<DesignRow, any> {
       
        protected getFormKey() { return DesignForm.formKey; }
        protected getIdProperty() { return DesignRow.idProperty; }
        protected getLocalTextPrefix() { return DesignRow.localTextPrefix; }
        protected getNameProperty() { return DesignRow.nameProperty; }
        protected getService() { return DesignService.baseUrl; }
        protected getInsertPermission() { return DesignRow.insertPermission; }
        protected getUpdatePermission() { return DesignRow.updatePermission; }
        protected getDeletePermission() { return DesignRow.deletePermission; }
        protected get_ExtDialogOptions(): ExtDialogOptions { return Q.deepClone(q.DefaultEntityDialogOptions); }
        protected useViewMode() { return true; }

        public form = new DesignForm(this.idPrefix);
        public isReadOnly = this.isViewMode();

        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            //q.initBOMEditor(this, this.form.BOMDetails, Config); 


            q.hideEditorLabel(this.form.BOMDetails); 
            q.hideEditorLabel(this.form.ImageName);
            q.hideEditorLabel(this.form.Image1);
            q.hideEditorLabel(this.form.Image2);
            q.hideEditorLabel(this.form.Image3); 
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.DiamondPieces);
            q.setTextRightAlign(this.form.DiamondWeight);
            q.setTextRightAlign(this.form.StonePieces);
            q.setTextRightAlign(this.form.StoneWeight);
            q.setTextRightAlign(this.form.OtherPieces);
            q.setTextRightAlign(this.form.OtherWeight);
            //q.setTextRightAlign(this.form.UnitLabour);
            //q.setTextRightAlign(this.form.LaborMarkup);
            //q.setTextRightAlign(this.form.PriceMarkup);
            q.setTextRightAlign(this.form.Pieces);
            //q.setTextRightAlign(this.form.Rate);
            q.setTextRightAlign(this.form.Purity);

            q.SetCategorySixColumn(this.form.DesignCode);
            q.SetCategorySixColumn(this.form.Image1);
            q.SetSix12Column(this.form.BOMDetails);
            q.SetCategoryTwoColumn(this.form.Pieces);
            q.SetCategoryFourColumn(this.form.DiamondPieces); 
            q.SetSix12Column(this.form.Remarks);

            q.HideCategoryLable(this.element);
            q.hideEditorLabel(this.form.Image4);
            q.hideEditorLabel(this.form.Image5);
            q.hideEditorLabel(this.form.Image6);
            q.hideEditorLabel(this.form.Image7);
            q.hideEditorLabel(this.form.Image8);
            q.hideEditorLabel(this.form.Video1);
            q.hideEditorLabel(this.form.Video2);


            this.form.HasBom.changeSelect2(e => {
                if (this.form.HasBom.value == true) {

                    Serenity.EditorUtils.setReadOnly(this.form.BOMDetails, false);
                    this.form.BOMDetails.EnableAddButton();
                    Serenity.EditorUtils.setReadOnly(this.form.NetWeight, true);
                    Serenity.EditorUtils.setReadOnly(this.form.Weight, true);
                    Serenity.EditorUtils.setReadOnly(this.form.OtherPieces, true);
                    Serenity.EditorUtils.setReadOnly(this.form.OtherWeight, true);
                    Serenity.EditorUtils.setReadOnly(this.form.StoneWeight, true);
                    Serenity.EditorUtils.setReadOnly(this.form.StonePieces, true);
                    Serenity.EditorUtils.setReadOnly(this.form.DiamondWeight, true);
                    Serenity.EditorUtils.setReadOnly(this.form.DiamondPieces, true);

                } else {
                    Serenity.EditorUtils.setReadOnly(this.form.BOMDetails, true);
                    this.form.BOMDetails.DisableAddButton();

                    Serenity.EditorUtils.setReadOnly(this.form.NetWeight, false);
                    Serenity.EditorUtils.setReadOnly(this.form.Weight, false);
                    Serenity.EditorUtils.setReadOnly(this.form.OtherPieces, false);
                    Serenity.EditorUtils.setReadOnly(this.form.OtherWeight, false);
                    Serenity.EditorUtils.setReadOnly(this.form.StoneWeight, false);

                    Serenity.EditorUtils.setReadOnly(this.form.StonePieces, false);
                    Serenity.EditorUtils.setReadOnly(this.form.DiamondWeight, false);
                    Serenity.EditorUtils.setReadOnly(this.form.DiamondPieces, false);
                }
            });
            (this.form.BOMDetails.view as any).onRowCountChanged.subscribe(() => {
                this.CalculateTotals();
            });
             
            this.form.ProductTypeId.changeSelect2(e => {
                if (this.form.ProductTypeId.value != "") {
                    this.form.ItemTypeId.value = OMS.ProductTypeRow.getLookup().itemById[parseInt(this.form.ProductTypeId.value)].ItemTypeId;
                    this.entity.ItemTypeId = this.form.ItemTypeId.value;
                    this.form.CategoryId.ItemTypeId = this.form.ItemTypeId.value;
                    this.form.CategoryId.updateItems();
                    this.form.SubCategoryId.value = "";
                }
            });

            this.form.CategoryId.changeSelect2(e => {
                this.form.SubCategoryId.CategoryId = parseInt(this.form.CategoryId.value);
                this.form.ProductSizeId.CategoryId = parseInt(this.form.CategoryId.value);
                this.form.ProductSizeId.updateItems();
                this.form.SubCategoryId.updateItems();
            });

            this.form.SuperTypeId.changeSelect2(e => {
                this.form.AttributeId.value = "0";

            });

            //this.form.IsDefaultSKU.changeSelect2(e => {
            //    if (this.form.IsDefaultSKU.value)
            //        q.showAndSetRequiredField(this.form.SKU);
            //    else
            //        q.showAndDisableField(this.form.SKU);

            //});


            this.form.Purity.changeSelect2(e => {
                var AttID = Q.toId(this.form.KaratId.value);
                var purity: OMS.AttributeMasterRow;
                OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(AttID) }, response => {
                    purity = response.Entity
                }, { async: false });
                var min = purity.MinPurity;
                var max = purity.MaxPurity;
                var std = purity.StdPurity;
                var current = this.form.Purity.value;
                if (current < min || current > max) {
                    Q.alert("Enter Purity between  " + min.toString() + "  to  " + max.toString());
                    this.form.Purity.value = std;
                }


            });

            this.form.KaratId.changeSelect2(e => {
                var AttID = Q.toId(this.form.KaratId.value);
                var purity: OMS.AttributeMasterRow;
                OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(AttID) }, response => {
                    purity = response.Entity
                }, { async: false });
                var std = purity.StdPurity;
                this.form.Purity.value = std;
            });


            this.form.DesignCode.changeSelect2(e => {
                try {

                    let PrdId = 0;
                    var equalFilter = { "DesignCode": this.form.DesignCode.value.toUpperCase() };

                    OMS.DesignService.List({ EqualityFilter: equalFilter, Take: 1 },
                        response => {
                            if (response.Entities.length > 0)
                                PrdId = response.Entities[0].DesignId;
                        }, {
                        async: false
                    }
                    );

                    if (PrdId > 0) {
                        Q.notifyError("Duplicate Design Code " + this.form.DesignCode.value);
                        this.form.DesignCode.value = "";
                        this.form.DesignCode.element.focus();
                        return;
                    }
                    else {
                        this.form.DesignCode.value = this.form.DesignCode.value.toUpperCase();

                    }

                }
                catch (undefined) {

                }
            });

            this.form.MetalId.changeSelect2(e => {
                this.form.MetalId.value = this.form.MetalId.value;

            });

        }
        CalculateTotals() {
            if (!this.isViewMode()) {
                var Pcs = 0, Wt = 0, othrpcs = 0, othrwt = 0, clrpcs = 0, clrwt = 0, diapcs = 0, diawt = 0, grswt = 0, cts = 0, gms = 0, rate = 0;
                var LAmount = 0;
                var Wst = 0;
                for (var k of this.form.BOMDetails.getItems()) {

                    if (k.ItemTypeId == 104) {
                        Wt += k.Weight;
                    }
                    if (k.ItemTypeId == 105 && k.CalcOnId == 5) {
                        cts += k.Weight;
                        diapcs += k.Pieces
                    }
                    if (k.ItemTypeId == 105 && k.CalcOnId == 4) {
                        gms += k.Weight;
                        clrpcs += k.Pieces;
                    }

                    //rate += k.BomAmount;
                }

                this.form.NetWeight.value = parseFloat(Wt.toFixed(3));
                this.form.OtherPieces.value = othrpcs;
                this.form.StonePieces.value = clrpcs;
                this.form.StoneWeight.value = gms;
                this.form.DiamondPieces.value = diapcs;
                this.form.DiamondWeight.value = cts;
                this.form.Weight.value = Wt + gms + (cts / 5);
                this.form.StonePieces.value = Pcs;
                //this.form.Rate.value = rate;
                this.form.ItemTypeId.value = 101; 
            }
        }

        getDesign() {
            return this.entity;
        }
        protected onDialogOpen() {
            super.onDialogOpen();

            if (this.form.HasBom.value == true) {

                Serenity.EditorUtils.setReadOnly(this.form.BOMDetails, false);
                this.form.BOMDetails.EnableAddButton();
                Serenity.EditorUtils.setReadOnly(this.form.NetWeight, true);
                Serenity.EditorUtils.setReadOnly(this.form.Weight, true);
                Serenity.EditorUtils.setReadOnly(this.form.OtherPieces, true);
                Serenity.EditorUtils.setReadOnly(this.form.OtherWeight, true);
                Serenity.EditorUtils.setReadOnly(this.form.StoneWeight, true);
                Serenity.EditorUtils.setReadOnly(this.form.StonePieces, true);
                Serenity.EditorUtils.setReadOnly(this.form.DiamondWeight, true);
                Serenity.EditorUtils.setReadOnly(this.form.DiamondPieces, true);

            } else {
                Serenity.EditorUtils.setReadOnly(this.form.BOMDetails, true);
                this.form.BOMDetails.DisableAddButton();
                var data = [];
                this.form.BOMDetails.setItems(data);
                this.form.BOMDetails.render;

                Serenity.EditorUtils.setReadOnly(this.form.NetWeight, false);
                Serenity.EditorUtils.setReadOnly(this.form.Weight, false);
                Serenity.EditorUtils.setReadOnly(this.form.OtherPieces, false);
                Serenity.EditorUtils.setReadOnly(this.form.OtherWeight, false);
                Serenity.EditorUtils.setReadOnly(this.form.StoneWeight, false);
                Serenity.EditorUtils.setReadOnly(this.form.StonePieces, false);
                Serenity.EditorUtils.setReadOnly(this.form.DiamondWeight, false);
                Serenity.EditorUtils.setReadOnly(this.form.DiamondPieces, false);

            }
            //q.hideField(this.form.DesignEnquiryType);
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.form.CategoryId.ItemTypeId = 101;

            //this.form.CategoryId.updateItems();
            if (this.form.HasBom.value == true) {

                Serenity.EditorUtils.setReadOnly(this.form.BOMDetails, false);
                this.form.BOMDetails.EnableAddButton();
                Serenity.EditorUtils.setReadOnly(this.form.NetWeight, true);
                Serenity.EditorUtils.setReadOnly(this.form.Weight, true);
                Serenity.EditorUtils.setReadOnly(this.form.OtherPieces, true);
                Serenity.EditorUtils.setReadOnly(this.form.OtherWeight, true);
                Serenity.EditorUtils.setReadOnly(this.form.StoneWeight, true);
                Serenity.EditorUtils.setReadOnly(this.form.StonePieces, true);
                Serenity.EditorUtils.setReadOnly(this.form.DiamondWeight, true);
                Serenity.EditorUtils.setReadOnly(this.form.DiamondPieces, true);
            }
            else {
                Serenity.EditorUtils.setReadOnly(this.form.BOMDetails, true);
                this.form.BOMDetails.DisableAddButton();
                var data = [];
                this.form.BOMDetails.setItems(data);
                this.form.BOMDetails.render;

                Serenity.EditorUtils.setReadOnly(this.form.NetWeight, false);
                Serenity.EditorUtils.setReadOnly(this.form.Weight, false);
                Serenity.EditorUtils.setReadOnly(this.form.OtherPieces, false);
                Serenity.EditorUtils.setReadOnly(this.form.OtherWeight, false);
                Serenity.EditorUtils.setReadOnly(this.form.StoneWeight, false);
                Serenity.EditorUtils.setReadOnly(this.form.StonePieces, false);
                Serenity.EditorUtils.setReadOnly(this.form.DiamondWeight, false);
                Serenity.EditorUtils.setReadOnly(this.form.DiamondPieces, false);

            }

        }

        protected getCloningEntity() {
            var clone = super.getCloningEntity();

            clone.DesignCode = null;
            clone.DesignName = null;
            if (clone.HasBom) {
                for (var bom of clone.BOMDetails) {
                    switch (bom.ItemTypeId) {
                        case 104:
                            bom.KaratId = null;
                            bom.MetalColorId = null;
                            break;
                        case 105:
                            bom.StoneColorId = null;
                            bom.QualityId = null;
                            break;

                    }
                }
            }
            return clone;
        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();
            return btns;
        }

        protected updateInterface() {
            super.updateInterface();
            this.cloneButton.toggle(this.isEditMode());
        }
    }
}

